var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.452,
    height: 18.454,
    viewBox: "0 0 18.452 18.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#455079;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.452,6.834a.923.923,0,0,0-.268-.655L16.273,2.268a.936.936,0,0,0-1.31,0L12.352,4.879h0L2.268,14.963A.923.923,0,0,0,2,15.618V19.53a.923.923,0,0,0,.923.923H6.834a.923.923,0,0,0,.7-.268L17.564,10.1h0l2.62-2.565a1.1,1.1,0,0,0,.2-.3.923.923,0,0,0,0-.221.646.646,0,0,0,0-.129Zm-3.534,1.31L14.308,5.534l1.31-1.3,2.6,2.6Z",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.a5566b129c3ccfbce35d4d566b30f1dc.svg";
export { ForwardRef as ReactComponent };